const PENDING_STATUS = 'pending'
const UNDER_REVIEW_STATUS = 'under_review'
const APPROVED_STATUS = 'approved'
const REFUSED_STATUS = 'refused'

const PENDING_LABEL = 'PENDENTE'
const UNDER_REVIEW_LABEL = 'REVISÃO'
const APPROVED_LABEL = 'APROVADO'
const REFUSED_LABEL = 'REPROVADO'

const STATUSES = {
  PENDING_STATUS,
  UNDER_REVIEW_STATUS,
  APPROVED_STATUS,
  REFUSED_STATUS,
}

const STATUSES_LABELS = {
  PENDING_LABEL,
  UNDER_REVIEW_LABEL,
  APPROVED_LABEL,
  REFUSED_LABEL,
}

const accounts = {
  STATUSES,
  STATUSES_LABELS,
}

export default accounts
